import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const TRANSLATIONS = {
  es: {
    nav: ['Funcionalidades', 'Cómo funciona', 'Planes', 'Contacto'],
    navIds: ['funcionalidades', 'como-funciona', 'precios', 'contacto'],
    navCta: 'Acceso negocios',
    downloadCta: 'Descargar app',
    downloadBarTextTop: 'Descarga la app Fidelize y acumula puntos en tus comercios favoritos',
    downloadBarTextBottom: '¿Ya eres cliente? No olvides descargar la app',
    downloadBarBtn: 'Descargar',
    heroTitle1: 'La fidelización digital',
    heroTitle2: 'sencilla y efectiva',
    heroSub: 'Tarjetas de fidelidad digitales para tu comercio. Escaneo QR, tecnología NFC, notificaciones y estadísticas — todo desde una sola plataforma.',
    heroCta2: 'Ver planes',
    badge1: 'App iOS & Android',
    badge2: 'Tecnología NFC',
    badge3: 'Estadísticas en tiempo real',
    trustedByLabel: 'Confían en nosotros',
    featuresLabel: 'Funcionalidades',
    featuresTitle: 'Todo lo que tu comercio necesita',
    f1t: 'App cliente', f1d: 'Tus clientes acumulan puntos y consultan sus recompensas directamente desde su smartphone.',
    f2t: 'Escaneo QR', f2d: 'El comercio escanea el código QR del cliente en segundos. Sin contacto, sin papel, sin fricción.',
    f3t: 'Tarjeta NFC', f3d: 'Con la tarjeta NFC Fidelize, un simple toque registra los puntos automáticamente. Disponible en plan Standard.',
    f4t: 'Notificaciones push', f4d: 'Envía ofertas, recordatorios y noticias directamente al móvil de tus clientes fidelizados.',
    f5t: 'Estadísticas', f5d: 'Visitas, puntos entregados, regalos canjeados, distribución por género y edad. Toma decisiones basadas en datos.',
    f6t: 'Sistema de regalos', f6d: 'Configura los umbrales de puntos para desbloquear recompensas y motivar a tus clientes a volver.',
    f7t: 'Encuestas', f7d: 'Recopila opiniones directas de tus clientes con encuestas enviadas desde la plataforma.',
    f8t: 'Fidelize +', f8d: 'Estrategia de niveles personalizados (básico, intermedio, avanzado) para recompensar la lealtad progresiva.',
    analyticsLabel: 'Panel de análisis',
    analyticsTitle: 'Mucho más que puntos y tarjetas',
    analyticsSub: 'Un nivel de detalle que la mayoría de la competencia no ofrece.',
    analyticsItems: [
      { t: 'Retención y conversión', d: 'Sabe qué clientes vuelven y cuáles estás perdiendo.' },
      { t: 'Ranking de clientes más fieles', d: 'Identifica a tus mejores clientes de un vistazo.' },
      { t: 'Horarios de mayor actividad', d: 'Descubre cuándo llegan realmente tus clientes.' },
      { t: 'Comparativa entre locales', d: 'Compara el rendimiento entre tus distintos locales.' },
      { t: 'Perfil de tus clientes', d: 'Entiende mejor quién te visita.' },
      { t: 'Evolución en el tiempo', d: 'Sigue la tendencia real de tu negocio.' },
    ],
    howLabel: '¿Cómo funciona?',
    howTitle: 'En 3 pasos sencillos',
    s1t: 'Registro del comercio', s1d: 'Te acompañamos en la creación y configuración de tu cuenta, y definimos tu estrategia de fidelización.',
    s2t: 'El cliente presenta su código', s2d: 'Al pagar, el cliente muestra su código QR o acerca su celular a la tarjeta NFC del comercio. El comercio escanea y los puntos se registran al instante.',
    s3t: 'Fideliza y comunica', s3d: 'Cuando el cliente acumula suficientes puntos, recibe su regalo. Usa las notificaciones para mantener el vínculo.',
    pricingLabel: 'Planes',
    pricingTitle: 'Elige un plan a tu medida',
    pricingSub: 'Sin compromisos. Cancela cuando quieras.',
    recommended: 'Recomendado',
    planBasicTag: 'Activa',
    planStdTag: 'Avanza',
    planPremTag: 'Destaca',
    planBasicFeatures: ['Aplicación Fidelize', 'Módulo de administración', 'Gestión de cuenta', 'Gestión de usuario (1 u.)', 'Retroalimentación', 'Hasta 1 local', 'Soporte básico'],
    planStdFeatures: ['Incluye plan básico', 'N° ilimitado de usuarios', 'Hasta 3 locales', 'Tarjeta NFC Fidelize', '20 notificaciones', '4 encuestas', 'Estadísticas básicas', 'Publicidad Instagram'],
    planPremFeatures: ['Incluye plan Standard', '+3 locales', '2 Tarjetas NFC por local', 'Notificaciones ilimitadas', 'Estadísticas avanzadas', 'Publicidad Instagram', 'Encuestas ilimitadas', 'Soporte prioritario'],
    fidelizePlusDesc: 'Estrategia de fidelización personalizada con niveles de lealtad (básico, intermedio, avanzado). Recompensa la lealtad progresiva de tus mejores clientes.',
    planContactCta: 'Contáctanos',
    ctaTitle1: '¿Listo para fidelizar',
    ctaTitle2: 'a tus clientes?',
    ctaSub: '¿Quieres ofrecer Fidelize a tus clientes? Contáctanos y te ayudamos a crear tu comercio, configurar tu estrategia de fidelización y empezar a fidelizar desde el primer día.',
    terms: 'Términos de uso',
    privacy: 'Privacidad',
  },
  fr: {
    nav: ['Fonctionnalités', 'Comment ça marche', 'Plans', 'Contact'],
    navIds: ['funcionalidades', 'como-funciona', 'precios', 'contacto'],
    navCta: 'Accès commerces',
    downloadCta: 'Télécharger l\'app',
    downloadBarTextTop: 'Téléchargez l\'app Fidelize et cumulez des points chez vos commerces préférés',
    downloadBarTextBottom: 'Vous êtes déjà client ? N\'oubliez pas de télécharger l\'app',
    downloadBarBtn: 'Télécharger',
    heroTitle1: 'La fidélisation digitale',
    heroTitle2: 'simple et efficace',
    heroSub: 'Cartes de fidélité digitales pour votre commerce. Scan QR, technologie NFC, notifications push et statistiques — tout en une seule plateforme.',
    heroCta2: 'Voir les offres',
    badge1: 'App iOS & Android',
    badge2: 'Technologie NFC',
    badge3: 'Statistiques en temps réel',
    trustedByLabel: 'Ils nous font confiance',
    featuresLabel: 'Fonctionnalités',
    featuresTitle: 'Tout ce dont votre commerce a besoin',
    f1t: 'App client', f1d: 'Vos clients cumulent des points et consultent leurs récompenses directement depuis leur smartphone.',
    f2t: 'Scan QR', f2d: 'Le commerce scanne le QR code du client en quelques secondes. Sans contact, sans papier, sans friction.',
    f3t: 'Carte NFC', f3d: 'Avec la carte NFC Fidelize, un simple effleurement enregistre les points automatiquement. Disponible avec le plan Standard.',
    f4t: 'Notifications push', f4d: 'Envoyez des offres, rappels et actualités directement sur le téléphone de vos clients fidèles.',
    f5t: 'Statistiques', f5d: 'Visites, points attribués, cadeaux échangés, répartition par genre et âge. Prenez des décisions basées sur les données.',
    f6t: 'Système de cadeaux', f6d: "Configurez les seuils de points pour débloquer des récompenses et inciter vos clients à revenir.",
    f7t: 'Sondages', f7d: 'Recueillez les avis directs de vos clients grâce à des sondages envoyés depuis la plateforme.',
    f8t: 'Fidelize +', f8d: 'Stratégie de niveaux personnalisés (basique, intermédiaire, avancé) pour récompenser la fidélité progressive.',
    analyticsLabel: 'Panneau d\'analyse',
    analyticsTitle: 'Bien plus que des points et des cartes',
    analyticsSub: 'Un niveau de détail que la plupart des concurrents n\'offrent pas.',
    analyticsItems: [
      { t: 'Rétention et conversion', d: 'Sachez quels clients reviennent et lesquels vous perdez.' },
      { t: 'Classement des clients les plus fidèles', d: 'Identifiez vos meilleurs clients en un coup d\'œil.' },
      { t: 'Horaires de forte affluence', d: 'Découvrez quand vos clients viennent réellement.' },
      { t: 'Comparatif entre établissements', d: 'Comparez la performance entre vos établissements.' },
      { t: 'Profil de vos clients', d: 'Comprenez mieux qui vous rend visite.' },
      { t: 'Évolution dans le temps', d: 'Suivez la vraie tendance de votre activité.' },
    ],
    howLabel: 'Comment ça marche ?',
    howTitle: '3 étapes simples',
    s1t: 'Inscription du commerce', s1d: 'Nous vous accompagnons dans la création et la configuration de votre compte, et définissons votre stratégie de fidélisation.',
    s2t: 'Le client présente son code', s2d: "Au moment du paiement, le client montre son QR code ou approche son téléphone de la carte NFC du commerce. Le commerce scanne et les points sont enregistrés instantanément.",
    s3t: 'Fidélisez et communiquez', s3d: "Quand le client a accumulé suffisamment de points, il reçoit son cadeau. Utilisez les notifications pour maintenir le lien.",
    pricingLabel: 'Plans',
    pricingTitle: 'Choisissez l\'offre qui vous convient',
    pricingSub: 'Sans engagement. Résiliez quand vous voulez.',
    recommended: 'Recommandé',
    planBasicTag: 'Démarrez',
    planStdTag: 'Progressez',
    planPremTag: 'Démarquez-vous',
    planBasicFeatures: ['Application Fidelize', 'Module d\'administration', 'Gestion du compte', 'Gestion utilisateur (1 u.)', 'Avis clients', 'Jusqu\'à 1 établissement', 'Support de base'],
    planStdFeatures: ['Inclut le plan Basic', 'Utilisateurs illimités', 'Jusqu\'à 3 établissements', 'Carte NFC Fidelize', '20 notifications', '4 sondages', 'Statistiques de base', 'Publicité Instagram'],
    planPremFeatures: ['Inclut le plan Standard', '+3 établissements', '2 cartes NFC par établissement', 'Notifications illimitées', 'Statistiques avancées', 'Publicité Instagram', 'Sondages illimités', 'Support prioritaire'],
    fidelizePlusDesc: 'Stratégie de fidélisation personnalisée avec des niveaux de loyauté (basique, intermédiaire, avancé). Récompensez la fidélité progressive de vos meilleurs clients.',
    planContactCta: 'Contactez-nous',
    ctaTitle1: 'Prêt à fidéliser',
    ctaTitle2: 'vos clients ?',
    ctaSub: 'Vous souhaitez proposer Fidelize à vos clients ? Contactez-nous et nous vous aidons à créer votre commerce, configurer votre stratégie de fidélisation et commencer à fidéliser dès le premier jour.',
    terms: 'Conditions d\'utilisation',
    privacy: 'Confidentialité',
  },
  it: {
    nav: ['Funzionalità', 'Come funziona', 'Piani', 'Contatto'],
    navIds: ['funcionalidades', 'como-funciona', 'precios', 'contacto'],
    navCta: 'Accesso negozi',
    downloadCta: 'Scarica l\'app',
    downloadBarTextTop: 'Scarica l\'app Fidelize e accumula punti nei tuoi negozi preferiti',
    downloadBarTextBottom: 'Sei già cliente? Non dimenticare di scaricare l\'app',
    downloadBarBtn: 'Scarica',
    heroTitle1: 'La fidelizzazione digitale',
    heroTitle2: 'semplice ed efficace',
    heroSub: 'Carte fedeltà digitali per il tuo negozio. Scansione QR, tecnologia NFC, notifiche push e statistiche — tutto in un\'unica piattaforma.',
    heroCta2: 'Vedi i piani',
    badge1: 'App iOS & Android',
    badge2: 'Tecnologia NFC',
    badge3: 'Statistiche in tempo reale',
    trustedByLabel: 'Si fidano di noi',
    featuresLabel: 'Funzionalità',
    featuresTitle: 'Tutto ciò di cui il tuo negozio ha bisogno',
    f1t: 'App cliente', f1d: 'I tuoi clienti accumulano punti e consultano i loro premi direttamente dallo smartphone.',
    f2t: 'Scansione QR', f2d: 'Il negozio scansiona il codice QR del cliente in pochi secondi. Senza contatto, senza carta, senza attrito.',
    f3t: 'Carta NFC', f3d: 'Con la carta NFC Fidelize, un semplice tocco registra i punti automaticamente. Disponibile nel piano Standard.',
    f4t: 'Notifiche push', f4d: 'Invia offerte, promemoria e notizie direttamente sul cellulare dei tuoi clienti fidelizzati.',
    f5t: 'Statistiche', f5d: 'Visite, punti assegnati, premi riscattati, distribuzione per genere ed età. Prendi decisioni basate sui dati.',
    f6t: 'Sistema premi', f6d: 'Configura le soglie di punti per sbloccare ricompense e motivare i clienti a tornare.',
    f7t: 'Sondaggi', f7d: 'Raccogli feedback diretto dai tuoi clienti con sondaggi inviati dalla piattaforma.',
    f8t: 'Fidelize +', f8d: 'Strategia a livelli personalizzata (base, intermedio, avanzato) per premiare la fedeltà progressiva.',
    analyticsLabel: 'Pannello di analisi',
    analyticsTitle: 'Molto più di punti e carte',
    analyticsSub: 'Un livello di dettaglio che la maggior parte della concorrenza non offre.',
    analyticsItems: [
      { t: 'Retention e conversione', d: 'Scopri quali clienti tornano e quali stai perdendo.' },
      { t: 'Classifica dei clienti più fedeli', d: 'Identifica i tuoi migliori clienti a colpo d\'occhio.' },
      { t: 'Orari di maggiore affluenza', d: 'Scopri quando i clienti arrivano davvero.' },
      { t: 'Confronto tra locali', d: 'Confronta le performance tra i tuoi locali.' },
      { t: 'Profilo dei tuoi clienti', d: 'Capisci meglio chi ti visita.' },
      { t: 'Evoluzione nel tempo', d: 'Segui il vero andamento del tuo business.' },
    ],
    howLabel: 'Come funziona?',
    howTitle: '3 semplici passi',
    s1t: 'Registrazione del negozio', s1d: 'Ti accompagniamo nella creazione e configurazione del tuo account, e definiamo la tua strategia di fidelizzazione.',
    s2t: 'Il cliente presenta il codice', s2d: 'Al momento del pagamento, il cliente mostra il QR code o avvicina il telefono alla carta NFC del negozio. Il negozio scansiona e i punti vengono registrati immediatamente.',
    s3t: 'Fidelizza e comunica', s3d: 'Quando il cliente accumula abbastanza punti, riceve il suo premio. Usa le notifiche per mantenere il contatto.',
    pricingLabel: 'Piani',
    pricingTitle: 'Scegli il piano più adatto a te',
    pricingSub: 'Senza vincoli. Disdici quando vuoi.',
    recommended: 'Consigliato',
    planBasicTag: 'Inizia',
    planStdTag: 'Cresci',
    planPremTag: 'Distinguiti',
    planBasicFeatures: ['Applicazione Fidelize', 'Modulo di amministrazione', 'Gestione account', 'Gestione utente (1 u.)', 'Feedback clienti', 'Fino a 1 locale', 'Supporto base'],
    planStdFeatures: ['Include piano Basic', 'Utenti illimitati', 'Fino a 3 locali', 'Carta NFC Fidelize', '20 notifiche', '4 sondaggi', 'Statistiche base', 'Pubblicità Instagram'],
    planPremFeatures: ['Include piano Standard', '+3 locali', '2 carte NFC per locale', 'Notifiche illimitate', 'Statistiche avanzate', 'Pubblicità Instagram', 'Sondaggi illimitati', 'Supporto prioritario'],
    fidelizePlusDesc: 'Strategia di fidelizzazione personalizzata con livelli di fedeltà (base, intermedio, avanzato). Premia la fedeltà progressiva dei tuoi migliori clienti.',
    planContactCta: 'Contattaci',
    ctaTitle1: 'Pronto a fidelizzare',
    ctaTitle2: 'i tuoi clienti?',
    ctaSub: 'Vuoi offrire Fidelize ai tuoi clienti? Contattaci e ti aiutiamo a creare il tuo negozio, configurare la tua strategia di fidelizzazione e iniziare a fidelizzare dal primo giorno.',
    terms: 'Termini di utilizzo',
    privacy: 'Privacy',
  },
  en: {
    nav: ['Features', 'How it works', 'Plans', 'Contact'],
    navIds: ['funcionalidades', 'como-funciona', 'precios', 'contacto'],
    navCta: 'Business login',
    downloadCta: 'Download app',
    downloadBarTextTop: 'Download the Fidelize app and earn points at your favorite stores',
    downloadBarTextBottom: 'Already a customer? Don\'t forget to download the app',
    downloadBarBtn: 'Download',
    heroTitle1: 'Digital loyalty',
    heroTitle2: 'simple and effective',
    heroSub: 'Digital loyalty cards for your business. QR scanning, NFC technology, push notifications and analytics — all in one platform.',
    heroCta2: 'See plans',
    badge1: 'iOS & Android App',
    badge2: 'NFC Technology',
    badge3: 'Real-time analytics',
    trustedByLabel: 'Trusted by',
    featuresLabel: 'Features',
    featuresTitle: 'Everything your business needs',
    f1t: 'Customer app', f1d: 'Your customers earn points and check their rewards directly from their smartphone.',
    f2t: 'QR scanning', f2d: 'The business scans the customer\'s QR code in seconds. Contactless, paperless, frictionless.',
    f3t: 'NFC card', f3d: 'With the Fidelize NFC card, a simple tap records points automatically. Available on the Standard plan.',
    f4t: 'Push notifications', f4d: 'Send offers, reminders and news directly to your loyal customers\' phones.',
    f5t: 'Analytics', f5d: 'Visits, points given, gifts redeemed, gender and age distribution. Make data-driven decisions.',
    f6t: 'Gift system', f6d: 'Set point thresholds to unlock rewards and motivate your customers to come back.',
    f7t: 'Surveys', f7d: 'Collect direct feedback from your customers with surveys sent from the platform.',
    f8t: 'Fidelize +', f8d: 'Personalised tier strategy (basic, intermediate, advanced) to reward progressive loyalty.',
    analyticsLabel: 'Analytics dashboard',
    analyticsTitle: 'Much more than points and cards',
    analyticsSub: 'A level of detail most competitors don\'t offer.',
    analyticsItems: [
      { t: 'Retention & conversion', d: 'Know which customers come back, and which you\'re losing.' },
      { t: 'Most loyal clients ranking', d: 'Spot your best customers at a glance.' },
      { t: 'Peak activity hours', d: 'Discover when customers really show up.' },
      { t: 'Location performance comparison', d: 'Compare performance across your locations.' },
      { t: 'Customer profile', d: 'Understand who is visiting you.' },
      { t: 'Trends over time', d: 'Track your business\'s real trend.' },
    ],
    howLabel: 'How it works',
    howTitle: '3 simple steps',
    s1t: 'Register your business', s1d: 'We guide you through creating and setting up your account, and define your loyalty strategy together.',
    s2t: 'Customer presents their code', s2d: 'At checkout, the customer shows their QR code or taps their phone against the business\'s NFC card. The business scans it and points are recorded instantly.',
    s3t: 'Reward and communicate', s3d: 'When the customer earns enough points, they receive their gift. Use notifications to stay connected.',
    pricingLabel: 'Plans',
    pricingTitle: 'Choose a plan that fits you',
    pricingSub: 'No commitments. Cancel anytime.',
    recommended: 'Recommended',
    planBasicTag: 'Get started',
    planStdTag: 'Grow',
    planPremTag: 'Stand out',
    planBasicFeatures: ['Fidelize app', 'Admin dashboard', 'Account management', 'User management (1 user)', 'Customer feedback', 'Up to 1 location', 'Basic support'],
    planStdFeatures: ['Includes Basic plan', 'Unlimited users', 'Up to 3 locations', 'Fidelize NFC card', '20 push notifications', '4 surveys', 'Basic analytics', 'Instagram ads'],
    planPremFeatures: ['Includes Standard plan', '+3 locations', '2 NFC cards per location', 'Unlimited push notifications', 'Advanced analytics', 'Instagram ads', 'Unlimited surveys', 'Priority support'],
    fidelizePlusDesc: 'Personalised loyalty strategy with loyalty tiers (basic, intermediate, advanced). Reward the progressive loyalty of your best customers.',
    planContactCta: 'Contact us',
    ctaTitle1: 'Ready to build loyalty',
    ctaTitle2: 'with your customers?',
    ctaSub: 'Want to offer Fidelize to your customers? Contact us and we\'ll help you set up your business, configure your loyalty strategy and start rewarding from day one.',
    terms: 'Terms of use',
    privacy: 'Privacy',
  },
};

const BRAND = '#3b95e8';
const BRAND_DARK = '#182B39';
const BRAND_MID = '#1e3a5f';
const TEXT = '#e8f0fe';
const MUTED = 'rgba(232,240,254,0.55)';
const CARD_BG = 'rgba(255,255,255,0.04)';
const CARD_BORDER = 'rgba(255,255,255,0.10)';

const CheckIcon = ({ color = BRAND }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0, marginTop: 2 }}>
    <rect width="16" height="16" rx="4" fill={color} fillOpacity="0.18" />
    <path d="M4 8l3 3 5-5" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const Feature = ({ icon, title, desc }) => (
  <div style={{
    background: CARD_BG,
    border: `1px solid ${CARD_BORDER}`,
    borderRadius: 16,
    padding: '24px 22px',
    flex: '1 1 220px',
    minWidth: 200,
    maxWidth: 280,
  }}>
    <div style={{
      width: 44, height: 44, borderRadius: 12,
      background: 'rgba(59,149,232,0.12)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      marginBottom: 14,
    }}>{icon}</div>
    <div style={{ fontSize: 15, fontWeight: 700, color: TEXT, marginBottom: 6 }}>{title}</div>
    <div style={{ fontSize: 13, color: MUTED, lineHeight: 1.6 }}>{desc}</div>
  </div>
);

const ic = (path, opts = {}) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
    stroke={BRAND} strokeWidth={opts.sw || 1.7}
    strokeLinecap="round" strokeLinejoin="round">
    {path}
  </svg>
);

const PlanCard = ({ name, tagline, features, highlighted, badge, addon, ctaLabel }) => (
  <div style={{
    background: highlighted ? 'linear-gradient(160deg, #1e3a5f 0%, #162d50 100%)' : CARD_BG,
    border: `1.5px solid ${highlighted ? BRAND : CARD_BORDER}`,
    borderRadius: 20,
    padding: addon ? '24px 24px 28px' : '28px 24px 32px',
    flex: addon ? 'none' : '1 1 220px',
    minWidth: addon ? 0 : 200,
    maxWidth: addon ? 480 : 300,
    width: addon ? '100%' : undefined,
    position: 'relative',
    boxShadow: highlighted ? '0 8px 40px rgba(59,149,232,0.22)' : 'none',
    boxSizing: 'border-box',
  }}>
    {badge && (
      <div style={{
        position: 'absolute', top: -14, right: 20,
        background: BRAND, color: '#fff',
        fontSize: 11, fontWeight: 800, letterSpacing: 0.5,
        padding: '4px 12px', borderRadius: 999,
        textTransform: 'uppercase',
      }}>{badge}</div>
    )}
    <div style={{ fontSize: addon ? 20 : 22, fontWeight: 800, color: highlighted ? '#fff' : TEXT, marginBottom: 4 }}>{name}</div>
    {tagline && <div style={{ fontSize: 12, color: MUTED, marginBottom: addon ? 8 : 16 }}>{tagline}</div>}
    {addon && (
      <div style={{ fontSize: 13, color: MUTED, lineHeight: 1.6, marginBottom: 16 }}>
        {addon}
      </div>
    )}
    {features && (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 24 }}>
        {features.map((f, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 9, fontSize: 13, color: highlighted ? 'rgba(232,240,254,0.9)' : MUTED }}>
            <CheckIcon color={highlighted ? '#7dd3fc' : BRAND} />
            <span>{f}</span>
          </div>
        ))}
      </div>
    )}
    <button
      onClick={() => document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth', block: 'start' })}
      style={{
        background: highlighted ? BRAND : 'rgba(59,149,232,0.12)',
        border: 'none',
        borderRadius: 12,
        padding: '13px 0',
        width: '100%',
        textAlign: 'center',
        cursor: 'pointer',
        fontSize: 15,
        fontWeight: 700,
        letterSpacing: 0.2,
        color: highlighted ? '#fff' : BRAND,
      }}
    >
      {ctaLabel}
    </button>
  </div>
);

const ANALYTICS_ICONS = [
  <><path d="M21 12a9 9 0 1 1-3-6.7"/><polyline points="21 3 21 9 15 9"/></>,
  <><path d="M3 21h18"/><rect x="5" y="14" width="4" height="7"/><rect x="10" y="9" width="4" height="12"/><rect x="15" y="4" width="4" height="17"/></>,
  <><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 16 14"/></>,
  <><path d="M21 10c0 6-9 12-9 12s-9-6-9-12a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></>,
  <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>,
  <><polyline points="3 17 9 11 13 15 21 7"/><polyline points="14 7 21 7 21 14"/></>,
].map((path, i) => <React.Fragment key={i}>{ic(path)}</React.Fragment>);

const AnalyticsPoint = ({ icon, title, desc }) => (
  <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start', flex: '1 1 260px', minWidth: 220 }}>
    <div style={{
      width: 40, height: 40, borderRadius: 10, flexShrink: 0,
      background: 'rgba(59,149,232,0.14)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>{icon}</div>
    <div>
      <div style={{ fontSize: 14, fontWeight: 700, color: TEXT, marginBottom: 3 }}>{title}</div>
      <div style={{ fontSize: 13, color: MUTED, lineHeight: 1.6 }}>{desc}</div>
    </div>
  </div>
);

const Step = ({ num, title, desc }) => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14, flex: '1 1 180px', minWidth: 160, maxWidth: 240, textAlign: 'center' }}>
    <div style={{
      width: 52, height: 52, borderRadius: '50%',
      background: 'linear-gradient(135deg, #3b95e8, #1e6ebf)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: 22, fontWeight: 800, color: '#fff',
      boxShadow: '0 4px 20px rgba(59,149,232,0.4)',
    }}>{num}</div>
    <div>
      <div style={{ fontSize: 15, fontWeight: 700, color: TEXT, marginBottom: 6 }}>{title}</div>
      <div style={{ fontSize: 13, color: MUTED, lineHeight: 1.6 }}>{desc}</div>
    </div>
  </div>
);

const Landing = () => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [lang, setLang] = useState('es');
  const t = TRANSLATIONS[lang];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div style={{
      background: 'linear-gradient(160deg, #0a1628 0%, #0f1f3d 50%, #0a1628 100%)',
      minHeight: '100vh',
      color: TEXT,
      fontFamily: 'system-ui, -apple-system, sans-serif',
      overflowX: 'hidden',
    }}>

      <style>{`
        .fdz-nav-links { display: flex; }
        .fdz-top-app-banner { display: none; }
        .fdz-bottom-app-bar { display: none; }
        @keyframes fdz-marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .fdz-marquee-track {
          animation: fdz-marquee 22s linear infinite;
        }
        .fdz-marquee-track:hover {
          animation-play-state: paused;
        }
        @media (max-width: 768px) {
          .fdz-nav-links { display: none; }
          .fdz-nav-right { gap: 6px !important; }
          .fdz-nav-lang-switch button { padding: 4px 7px !important; font-size: 11px !important; }
          .fdz-nav-cta { padding: 7px 14px !important; font-size: 13px !important; }
          nav { padding: 0 16px !important; }
          .fdz-top-app-banner { display: flex; }
          .fdz-bottom-app-bar { display: flex; }
          .fdz-hero-section { padding-top: 170px !important; }
          body { padding-bottom: 64px; }
        }
      `}</style>

      {/* ── Nav ── */}
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
        padding: '0 32px',
        height: 64,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        background: scrolled ? 'rgba(10,22,40,0.90)' : 'transparent',
        backdropFilter: scrolled ? 'blur(12px)' : 'none',
        borderBottom: scrolled ? '1px solid rgba(255,255,255,0.06)' : 'none',
        transition: 'all 0.25s',
        boxSizing: 'border-box',
      }}>
        <div style={{ fontFamily: 'FingerPaint, sans-serif', fontSize: 28, color: '#fff', letterSpacing: 1 }}>f</div>

        <div className="fdz-nav-links" style={{ alignItems: 'center', gap: 28 }}>
          {t.nav.map((label, i) => (
            <button
              key={t.navIds[i]}
              onClick={() => document.getElementById(t.navIds[i])?.scrollIntoView({ behavior: 'smooth', block: 'start' })}
              style={{
                background: 'none', border: 'none', padding: 0,
                fontSize: 14, fontWeight: 500,
                color: 'rgba(232,240,254,0.65)',
                cursor: 'pointer',
                transition: 'color 0.15s',
              }}
              onMouseEnter={e => e.currentTarget.style.color = '#fff'}
              onMouseLeave={e => e.currentTarget.style.color = 'rgba(232,240,254,0.65)'}
            >
              {label}
            </button>
          ))}
        </div>

        <div className="fdz-nav-right" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div className="fdz-nav-lang-switch" style={{
            display: 'flex', alignItems: 'center',
            background: 'rgba(255,255,255,0.06)',
            border: '1px solid rgba(255,255,255,0.10)',
            borderRadius: 8, overflow: 'hidden',
          }}>
            {['es', 'en', 'fr', 'it'].map((l) => (
              <button
                key={l}
                onClick={() => setLang(l)}
                style={{
                  background: lang === l ? 'rgba(59,149,232,0.25)' : 'none',
                  border: 'none',
                  padding: '5px 10px',
                  fontSize: 12, fontWeight: 700,
                  color: lang === l ? BRAND : 'rgba(232,240,254,0.45)',
                  cursor: 'pointer',
                  letterSpacing: 0.5,
                  textTransform: 'uppercase',
                  transition: 'all 0.15s',
                }}
              >{l}</button>
            ))}
          </div>
          <button
            onClick={() => navigate('/login')}
            className="fdz-nav-cta"
            style={{
              background: BRAND,
              color: '#fff',
              border: 'none',
              borderRadius: 10,
              padding: '9px 22px',
              fontSize: 14,
              fontWeight: 700,
              cursor: 'pointer',
              letterSpacing: 0.3,
              whiteSpace: 'nowrap',
            }}>
            {t.navCta}
          </button>
        </div>
      </nav>

      {/* ── Top app-download banner (mobile only) ── */}
      <div className="fdz-top-app-banner" style={{
        position: 'fixed', top: 64, left: 0, right: 0, zIndex: 90,
        alignItems: 'center', justifyContent: 'center',
        gap: 16,
        flexWrap: 'wrap',
        padding: '14px 20px',
        background: BRAND,
        boxShadow: '0 4px 20px rgba(0,0,0,0.25)',
        boxSizing: 'border-box',
      }}>
        <span style={{ fontSize: 15, fontWeight: 700, color: '#fff', textAlign: 'center' }}>
          {t.downloadBarTextTop}
        </span>
        <button
          onClick={() => navigate('/download')}
          style={{
            background: '#fff', color: BRAND,
            border: 'none', borderRadius: 10,
            padding: '12px 28px', fontSize: 15, fontWeight: 800,
            cursor: 'pointer', whiteSpace: 'nowrap',
            boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
          }}>
          {t.downloadBarBtn}
        </button>
      </div>

      {/* ── Hero ── */}
      <section className="fdz-hero-section" style={{
        minHeight: '92vh',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        textAlign: 'center',
        padding: '100px 24px 60px',
        position: 'relative',
        overflow: 'hidden',
      }}>
        {/* Background glow */}
        <div style={{
          position: 'absolute', top: '30%', left: '50%', transform: 'translate(-50%,-50%)',
          width: 600, height: 600, borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(59,149,232,0.12) 0%, transparent 70%)',
          pointerEvents: 'none',
        }} />

        <div style={{ fontFamily: 'FingerPaint, sans-serif', fontSize: 80, color: '#fff', marginBottom: 28, lineHeight: 1 }}>f</div>
        <h1 style={{
          fontSize: 'clamp(32px, 5vw, 58px)',
          fontWeight: 800, color: '#fff',
          margin: '0 0 20px',
          lineHeight: 1.15,
          letterSpacing: -1,
          maxWidth: 720,
        }}>
          {t.heroTitle1}<br />
          <span style={{ color: BRAND }}>{t.heroTitle2}</span>
        </h1>
        <p style={{
          fontSize: 'clamp(15px, 2vw, 18px)',
          color: MUTED, maxWidth: 560, margin: '0 auto 40px',
          lineHeight: 1.7,
        }}>
          {t.heroSub}
        </p>
        <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', justifyContent: 'center' }}>
          <button
            onClick={() => document.getElementById('precios')?.scrollIntoView({ behavior: 'smooth', block: 'start' })}
            style={{
              background: BRAND,
              color: '#fff', border: 'none',
              borderRadius: 12, padding: '14px 32px',
              fontSize: 16, fontWeight: 700, cursor: 'pointer',
              boxShadow: '0 6px 24px rgba(59,149,232,0.4)',
              letterSpacing: 0.3,
            }}>
            {t.heroCta2}
          </button>
        </div>

        {/* Floating badges */}
        <div style={{ display: 'flex', gap: 12, marginTop: 52, flexWrap: 'wrap', justifyContent: 'center' }}>
          {[
            { label: t.badge1, svg: <path d="M17 2H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z M12 18h.01" strokeLinecap="round"/> },
            { label: t.badge2, svg: <><path d="M12 2C8 2 5 5 5 9c0 5 7 13 7 13s7-8 7-13c0-4-3-7-7-7z"/><circle cx="12" cy="9" r="2.5"/></> },
            { label: t.badge3, svg: <><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></> },
          ].map(({ label, svg }) => (
            <span key={label} style={{
              background: 'rgba(255,255,255,0.06)', border: `1px solid ${CARD_BORDER}`,
              borderRadius: 999, padding: '7px 16px',
              fontSize: 13, color: MUTED,
              display: 'flex', alignItems: 'center', gap: 7,
            }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={BRAND} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">{svg}</svg>
              {label}
            </span>
          ))}
        </div>
      </section>

      {/* ── Features ── */}
      <section id="funcionalidades" style={{ padding: '80px 32px', maxWidth: 1100, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 52 }}>
          <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: 2, color: BRAND, textTransform: 'uppercase', marginBottom: 12 }}>
            {t.featuresLabel}
          </div>
          <h2 style={{ fontSize: 'clamp(24px, 3vw, 36px)', fontWeight: 800, color: '#fff', margin: 0, letterSpacing: -0.5 }}>
            {t.featuresTitle}
          </h2>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, justifyContent: 'center' }}>
          <Feature icon={ic(<><rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18" strokeWidth="2.5"/></>)} title={t.f1t} desc={t.f1d} />
          <Feature icon={ic(<><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><path d="M14 14h2v2h-2zM18 14h3M14 18h3M18 18h3M18 21h3" strokeWidth="1.5"/></>)} title={t.f2t} desc={t.f2d} />
          <Feature icon={ic(<><path d="M12 2C8 2 5 5 5 9c0 5 7 13 7 13s7-8 7-13c0-4-3-7-7-7z"/><circle cx="12" cy="9" r="2.5"/></>)} title={t.f3t} desc={t.f3d} />
          <Feature icon={ic(<><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></>)} title={t.f4t} desc={t.f4d} />
          <Feature icon={ic(<><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></>)} title={t.f5t} desc={t.f5d} />
          <Feature icon={ic(<><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5" rx="1"/><path d="M12 22V7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></>)} title={t.f6t} desc={t.f6d} />
          <Feature icon={ic(<><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></>)} title={t.f7t} desc={t.f7d} />
          <Feature icon={ic(<><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></>)} title={t.f8t} desc={t.f8d} />
        </div>
      </section>

      {/* ── Analytics highlight ── */}
      <section style={{ padding: '0 32px 80px', maxWidth: 1100, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: 2, color: BRAND, textTransform: 'uppercase', marginBottom: 12 }}>
            {t.analyticsLabel}
          </div>
          <h2 style={{ fontSize: 'clamp(24px, 3vw, 36px)', fontWeight: 800, color: '#fff', margin: '0 0 12px', letterSpacing: -0.5 }}>
            {t.analyticsTitle}
          </h2>
          <p style={{ fontSize: 15, color: MUTED, margin: '0 auto', maxWidth: 620, lineHeight: 1.7 }}>
            {t.analyticsSub}
          </p>
        </div>
        <div style={{
          background: 'linear-gradient(135deg, rgba(59,149,232,0.10) 0%, rgba(30,63,95,0.30) 100%)',
          border: `1.5px solid rgba(59,149,232,0.30)`,
          borderRadius: 24,
          padding: '36px 32px',
          boxSizing: 'border-box',
        }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '28px 32px' }}>
            {t.analyticsItems.map((item, i) => (
              <AnalyticsPoint key={item.t} icon={ANALYTICS_ICONS[i]} title={item.t} desc={item.d} />
            ))}
          </div>
        </div>
      </section>

      {/* ── How it works ── */}
      <section id="como-funciona" style={{
        padding: '80px 32px',
        background: 'rgba(255,255,255,0.02)',
        borderTop: `1px solid ${CARD_BORDER}`,
        borderBottom: `1px solid ${CARD_BORDER}`,
      }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: 56 }}>
            <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: 2, color: BRAND, textTransform: 'uppercase', marginBottom: 12 }}>
              {t.howLabel}
            </div>
            <h2 style={{ fontSize: 'clamp(24px, 3vw, 36px)', fontWeight: 800, color: '#fff', margin: 0, letterSpacing: -0.5 }}>
              {t.howTitle}
            </h2>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 32, justifyContent: 'center' }}>
            <Step num="1" title={t.s1t} desc={t.s1d} />
            <Step num="2" title={t.s2t} desc={t.s2d} />
            <Step num="3" title={t.s3t} desc={t.s3d} />
          </div>
        </div>
      </section>

      {/* ── Pricing ── */}
      <section id="precios" style={{ padding: '80px 32px', maxWidth: 1100, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 52 }}>
          <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: 2, color: BRAND, textTransform: 'uppercase', marginBottom: 12 }}>
            {t.pricingLabel}
          </div>
          <h2 style={{ fontSize: 'clamp(24px, 3vw, 36px)', fontWeight: 800, color: '#fff', margin: '0 0 12px', letterSpacing: -0.5 }}>
            {t.pricingTitle}
          </h2>
          <p style={{ fontSize: 15, color: MUTED, margin: 0 }}>{t.pricingSub}</p>
        </div>

        {/* Main 3 plans */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 20, justifyContent: 'center', marginBottom: 24 }}>
          <PlanCard
            name="Basic"
            tagline={t.planBasicTag}
            ctaLabel={t.planContactCta}
            features={t.planBasicFeatures}
          />
          <PlanCard
            name="Standard"
            tagline={t.planStdTag}
            ctaLabel={t.planContactCta}
            highlighted
            badge={t.recommended}
            features={t.planStdFeatures}
          />
          <PlanCard
            name="Premium"
            tagline={t.planPremTag}
            ctaLabel={t.planContactCta}
            features={t.planPremFeatures}
          />
        </div>

        {/* Fidelize+ addon */}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{
            background: 'linear-gradient(135deg, rgba(59,149,232,0.10) 0%, rgba(30,63,95,0.30) 100%)',
            border: `1.5px solid rgba(59,149,232,0.30)`,
            borderRadius: 20,
            padding: '28px 32px',
            maxWidth: 560,
            width: '100%',
            boxSizing: 'border-box',
            position: 'relative',
          }}>
            <div style={{
              position: 'absolute', top: -14, right: 20,
              background: BRAND, color: '#fff',
              fontSize: 11, fontWeight: 800, letterSpacing: 0.5,
              padding: '4px 12px', borderRadius: 999,
              textTransform: 'uppercase',
            }}>{t.recommended}</div>
            <div style={{ fontSize: 20, fontWeight: 800, color: TEXT, marginBottom: 4 }}>Fidelize +</div>
            <div style={{ fontSize: 13, color: MUTED, lineHeight: 1.6 }}>
              {t.fidelizePlusDesc}
            </div>
          </div>
        </div>
      </section>

      {/* ── Trusted by ── */}
      <section style={{
        padding: '36px 32px',
        borderTop: `1px solid ${CARD_BORDER}`,
        borderBottom: `1px solid ${CARD_BORDER}`,
      }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: 2, color: MUTED, textTransform: 'uppercase', marginBottom: 24, textAlign: 'center' }}>
            {t.trustedByLabel}
          </div>
          <div style={{
            overflow: 'hidden',
            maxWidth: 480,
            margin: '0 auto',
            WebkitMaskImage: 'linear-gradient(90deg, transparent 0, #000 32px, #000 calc(100% - 32px), transparent 100%)',
            maskImage: 'linear-gradient(90deg, transparent 0, #000 32px, #000 calc(100% - 32px), transparent 100%)',
          }}>
            <div className="fdz-marquee-track" style={{ display: 'flex', width: 'max-content', gap: 64 }}>
              {[0, 1].map((copy) => (
                [
                  { name: 'Eric Kayser', location: 'Las Condes · Vitacura' },
                  { name: 'Café Jardín', location: 'Providencia' },
                  { name: 'Nua Café', location: 'Providencia' },
                  { name: 'Asociación Cultural Italiana', location: 'Providencia' },
                ].map((client) => (
                  <div key={`${copy}-${client.name}`} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, flexShrink: 0 }}>
                    <span style={{ fontSize: 22, fontWeight: 700, color: 'rgba(232,240,254,0.55)', letterSpacing: 0.3, whiteSpace: 'nowrap' }}>{client.name}</span>
                    <span style={{ fontSize: 12, color: MUTED, whiteSpace: 'nowrap' }}>{client.location}</span>
                  </div>
                ))
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section id="contacto" style={{
        padding: '80px 32px',
        textAlign: 'center',
        background: 'linear-gradient(160deg, rgba(30,63,95,0.30) 0%, rgba(10,22,40,0) 100%)',
        borderTop: `1px solid ${CARD_BORDER}`,
      }}>
        <h2 style={{ fontSize: 'clamp(24px, 3vw, 40px)', fontWeight: 800, color: '#fff', margin: '0 0 16px', letterSpacing: -0.5 }}>
          {t.ctaTitle1}<br />{t.ctaTitle2}
        </h2>
        <p style={{ fontSize: 16, color: MUTED, margin: '0 auto 40px', maxWidth: 520, lineHeight: 1.7 }}>
          {t.ctaSub}
        </p>
        <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', justifyContent: 'center' }}>
          <a
            href="https://wa.me/56926244898"
            style={{
              background: '#25D366', color: '#fff',
              border: 'none', borderRadius: 14,
              padding: '16px 28px', fontSize: 16,
              fontWeight: 700, cursor: 'pointer',
              boxShadow: '0 8px 28px rgba(37,211,102,0.35)',
              letterSpacing: 0.3, textDecoration: 'none',
              display: 'inline-flex', alignItems: 'center', gap: 10,
            }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
          WhatsApp
          </a>
          <a
            href="mailto:contact@alpes-solutions.com"
            style={{
              background: 'rgba(255,255,255,0.07)', color: '#e8f0fe',
              border: '1px solid rgba(255,255,255,0.14)', borderRadius: 14,
              padding: '16px 28px', fontSize: 16,
              fontWeight: 600, cursor: 'pointer',
              letterSpacing: 0.3, textDecoration: 'none',
              display: 'inline-flex', alignItems: 'center', gap: 10,
            }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e8f0fe" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 7l10 7 10-7"/></svg>
            contact@alpes-solutions.com
          </a>
        </div>
      </section>

      {/* ── Footer ── */}
      <footer style={{
        borderTop: `1px solid ${CARD_BORDER}`,
        padding: '28px 32px',
        display: 'flex', flexWrap: 'wrap',
        alignItems: 'center', justifyContent: 'space-between',
        gap: 16,
        maxWidth: 1100, margin: '0 auto',
        boxSizing: 'border-box',
      }}>
        <span style={{ fontSize: 12, color: 'rgba(232,240,254,0.3)' }}>© {new Date().getFullYear()} Alpes Solutions</span>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 20, alignItems: 'center' }}>
          <a href="https://wa.me/56926244898" style={{ fontSize: 13, color: MUTED, textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 6 }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="#25D366"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
            +56 9 2624 4898
          </a>
          <a href="https://www.instagram.com/fidelize.chile" style={{ fontSize: 13, color: MUTED, textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 6 }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={MUTED} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
              <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
            </svg>
            Instagram
          </a>
          <a href="https://fidelize.org" style={{ fontSize: 13, color: MUTED, textDecoration: 'none' }}>fidelize.org</a>
          <a href={`/terms/${lang}`} style={{ fontSize: 13, color: MUTED, textDecoration: 'none' }}>{t.terms}</a>
          <a href={`/privacy/${lang}`} style={{ fontSize: 13, color: MUTED, textDecoration: 'none' }}>{t.privacy}</a>
        </div>
      </footer>

      {/* ── Bottom app-download bar (mobile only) ── */}
      <div className="fdz-bottom-app-bar" style={{
        position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 200,
        alignItems: 'center', justifyContent: 'space-between',
        gap: 10,
        padding: '10px 14px',
        paddingBottom: 'calc(10px + env(safe-area-inset-bottom))',
        background: BRAND,
        boxShadow: '0 -4px 20px rgba(0,0,0,0.25)',
        boxSizing: 'border-box',
      }}>
        <span style={{ flex: 1, fontSize: 13, fontWeight: 600, color: '#fff', lineHeight: 1.3 }}>
          {t.downloadBarTextBottom}
        </span>
        <button
          onClick={() => navigate('/download')}
          style={{
            background: '#fff', color: BRAND,
            border: 'none', borderRadius: 8,
            padding: '9px 16px', fontSize: 13, fontWeight: 700,
            cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0,
          }}>
          {t.downloadBarBtn}
        </button>
      </div>
    </div>
  );
};

export default Landing;
